import { Address } from "nodemailer/lib/mailer"

type BrandIDs = "canyouunlock.com"

export type Brand = {
  id: BrandIDs
  baseUrl: string
  name: string
  emailSender: Address
  mailto: string
  slackNotifyMemberId: string
  accounting: {
    // Specify as strings to keep precision when turned into decimals
    unlockingFeeRate: string
    taxWithholdingRate: string
    advanceFeeRate: string
  }
  theme: any
}

const makeBrand = <T extends Brand>(brand: T) => brand

export const brands: Record<BrandIDs, ReturnType<typeof makeBrand>> = {
  "canyouunlock.com": makeBrand({
    id: "canyouunlock.com",
    baseUrl: "https://can-you-unlock.vercel.app/",
    name: "CanYouUnlock",
    slackNotifyMemberId: "U03GXKEEX43", // Alex
    emailSender: {
      name: "CanYouUnlock",
      address: "info@canyouunlock.com",
    },
    mailto: "info@canyouunlock.com",
    accounting: {
      // Specify as strings to keep precision when turned into decimals
      unlockingFeeRate: "0.07",
      taxWithholdingRate: "0.3",
      advanceFeeRate: "0.1",
    },
    theme: {
      yellow: "#f7b64d",
      lightyellow: "#fffbf6",
      darkblue: "#0a3c5f",
    },
  }),
}

export const defaultBrand = "canyouunlock.com"

export const brand = brands[(process.env.BRAND as keyof typeof brands) ?? defaultBrand]
